module.exports = __webpack_public_path__ + "img/chinesecompany45.98d3963c.png";